import script from "./TagEditModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagEditModal.vue?vue&type=script&setup=true&lang=ts"

import "./TagEditModal.vue?vue&type=style&index=0&id=0119582e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0119582e"]])

export default __exports__